import { render, staticRenderFns } from "./ChannelDetails.vue?vue&type=template&id=43a809be&scoped=true&"
import script from "./ChannelDetails.vue?vue&type=script&lang=ts&"
export * from "./ChannelDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelDetails.vue?vue&type=style&index=0&id=43a809be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a809be",
  null
  
)

export default component.exports